import { StrictLocalizeFunction } from "../localization";

export const US_STATE_SHORTHAND_TO_NAME = (
  strictLocalize: StrictLocalizeFunction
) =>
  ({
    AL: strictLocalize({
      id: "9OHJaT",
      defaultMessage: "Alabama",
      description: { text: "US state" },
    }),
    AK: strictLocalize({
      id: "s9P30o",
      defaultMessage: "Alaska",
      description: { text: "US state" },
    }),
    AZ: strictLocalize({
      id: "X/j+Ze",
      defaultMessage: "Arizona",
      description: { text: "US state" },
    }),
    AR: strictLocalize({
      id: "apn5YA",
      defaultMessage: "Arkansas",
      description: { text: "US state" },
    }),
    CA: strictLocalize({
      id: "tBhA2o",
      defaultMessage: "California",
      description: { text: "US state" },
    }),
    CO: strictLocalize({
      id: "ikLCAP",
      defaultMessage: "Colorado",
      description: { text: "US state" },
    }),
    CT: strictLocalize({
      id: "W9uk7P",
      defaultMessage: "Connecticut",
      description: { text: "US state" },
    }),
    DE: strictLocalize({
      id: "XXoFHg",
      defaultMessage: "Delaware",
      description: { text: "US state" },
    }),
    DC: strictLocalize({
      id: "nwwjZO",
      defaultMessage: "District of Columbia",
      description: { text: "US district" },
    }),
    FL: strictLocalize({
      id: "ovfuEi",
      defaultMessage: "Florida",
      description: { text: "US state" },
    }),
    GA: strictLocalize({
      id: "blPLh7",
      defaultMessage: "Georgia",
      description: { text: "US state" },
    }),
    HI: strictLocalize({
      id: "Kluf63",
      defaultMessage: "Hawaii",
      description: { text: "US state" },
    }),
    ID: strictLocalize({
      id: "JOlq+R",
      defaultMessage: "Idaho",
      description: { text: "US state" },
    }),
    IL: strictLocalize({
      id: "SO0ovs",
      defaultMessage: "Illinois",
      description: { text: "US state" },
    }),
    IN: strictLocalize({
      id: "mrjRoI",
      defaultMessage: "Indiana",
      description: { text: "US state" },
    }),
    IA: strictLocalize({
      id: "+5Mc2r",
      defaultMessage: "Iowa",
      description: { text: "US state" },
    }),
    KS: strictLocalize({
      id: "C9cyUM",
      defaultMessage: "Kansas",
      description: { text: "US state" },
    }),
    KY: strictLocalize({
      id: "d+L/al",
      defaultMessage: "Kentucky",
      description: { text: "US state" },
    }),
    LA: strictLocalize({
      id: "QHVKG8",
      defaultMessage: "Louisiana",
      description: { text: "US state" },
    }),
    ME: strictLocalize({
      id: "8YHK11",
      defaultMessage: "Maine",
      description: { text: "US state" },
    }),
    MD: strictLocalize({
      id: "m+5G9G",
      defaultMessage: "Maryland",
      description: { text: "US state" },
    }),
    MA: strictLocalize({
      id: "IEyV3y",
      defaultMessage: "Massachusetts",
      description: { text: "US state" },
    }),
    MI: strictLocalize({
      id: "MQ7CdG",
      defaultMessage: "Michigan",
      description: { text: "US state" },
    }),
    MN: strictLocalize({
      id: "Ui4xw5",
      defaultMessage: "Minnesota",
      description: { text: "US state" },
    }),
    MS: strictLocalize({
      id: "SIIwQD",
      defaultMessage: "Mississippi",
      description: { text: "US state" },
    }),
    MO: strictLocalize({
      id: "NjC7SO",
      defaultMessage: "Missouri",
      description: { text: "US state" },
    }),
    MT: strictLocalize({
      id: "o5pWzk",
      defaultMessage: "Montana",
      description: { text: "US state" },
    }),
    NE: strictLocalize({
      id: "TDS4OY",
      defaultMessage: "Nebraska",
      description: { text: "US state" },
    }),
    NV: strictLocalize({
      id: "AieE/I",
      defaultMessage: "Nevada",
      description: { text: "US state" },
    }),
    NH: strictLocalize({
      id: "8HsdqY",
      defaultMessage: "New Hampshire",
      description: { text: "US state" },
    }),
    NJ: strictLocalize({
      id: "rQoo0D",
      defaultMessage: "New Jersey",
      description: { text: "US state" },
    }),
    NM: strictLocalize({
      id: "2+7veU",
      defaultMessage: "New Mexico",
      description: { text: "US state" },
    }),
    NY: strictLocalize({
      id: "eoxzbn",
      defaultMessage: "New York",
      description: { text: "US state" },
    }),
    NC: strictLocalize({
      id: "dNWPiM",
      defaultMessage: "North Carolina",
      description: { text: "US state" },
    }),
    ND: strictLocalize({
      id: "LhzOxJ",
      defaultMessage: "North Dakota",
      description: { text: "US state" },
    }),
    OH: strictLocalize({
      id: "bVCq79",
      defaultMessage: "Ohio",
      description: { text: "US state" },
    }),
    OK: strictLocalize({
      id: "OmaOQ7",
      defaultMessage: "Oklahoma",
      description: { text: "US state" },
    }),
    OR: strictLocalize({
      id: "jbbo9E",
      defaultMessage: "Oregon",
      description: { text: "US state" },
    }),
    PA: strictLocalize({
      id: "g/6EVF",
      defaultMessage: "Pennsylvania",
      description: { text: "US state" },
    }),
    PR: strictLocalize({
      id: "pMrro/",
      defaultMessage: "Puerto Rico",
      description: { text: "US territory" },
    }),
    RI: strictLocalize({
      id: "dnRl8T",
      defaultMessage: "Rhode Island",
      description: { text: "US state" },
    }),
    SC: strictLocalize({
      id: "5X2Aim",
      defaultMessage: "South Carolina",
      description: { text: "US state" },
    }),
    SD: strictLocalize({
      id: "r+W0bq",
      defaultMessage: "South Dakota",
      description: { text: "US state" },
    }),
    TN: strictLocalize({
      id: "UqB+Ms",
      defaultMessage: "Tennessee",
      description: { text: "US state" },
    }),
    TX: strictLocalize({
      id: "IbnAf+",
      defaultMessage: "Texas",
      description: { text: "US state" },
    }),
    UT: strictLocalize({
      id: "bj9jD2",
      defaultMessage: "Utah",
      description: { text: "US state" },
    }),
    VT: strictLocalize({
      id: "qgLLAo",
      defaultMessage: "Vermont",
      description: { text: "US state" },
    }),
    VA: strictLocalize({
      id: "Bc8NY7",
      defaultMessage: "Virginia",
      description: { text: "US state" },
    }),
    WA: strictLocalize({
      id: "134bj3",
      defaultMessage: "Washington",
      description: { text: "US state" },
    }),
    WV: strictLocalize({
      id: "EHTiRP",
      defaultMessage: "West Virginia",
      description: { text: "US state" },
    }),
    WI: strictLocalize({
      id: "vneOF5",
      defaultMessage: "Wisconsin",
      description: { text: "US state" },
    }),
    WY: strictLocalize({
      id: "K5R4pK",
      defaultMessage: "Wyoming",
      description: { text: "US state" },
    }),
  }) as const;
